import { Component } from '@angular/core';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { AbstractI18nService, BaseComponent } from '@libs/index';
import { takeUntil } from 'rxjs/operators';
import { LanguageSelectionDialogComponent } from '@libs/index';
import { DialogService } from '@libs/index';
import { Language } from '@libs/index';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent extends BaseComponent {
  public selectedLanguage: Language;

  constructor(
    private dialogService: DialogService,
    private i18nService: AbstractI18nService,
    private navigationService: NavigationService
  ) {
    super();

    this.i18nService.selectedLanguage$
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((l) => (this.selectedLanguage = l));
  }

  public async navigateToPublicHomePage() {
    await this.navigationService.navigateToHome();
  }

  public async navigateToPublicImprintPage() {
    await this.navigationService.navigateToImprint();
  }

  public async navigateToPublicPrivacyPolicyPage() {
    await this.navigationService.navigateToPrivacyPolicy();
  }

  public openLanguageDialog(): void {
    this.dialogService.openDialog(
      LanguageSelectionDialogComponent,
      this.dialogService.createSmallDialogConfig(null)
    );
  }
}
